// extracted by mini-css-extract-plugin
export default {"PickerList":"discovery-suggestions-module__PickerList--vCRzA","isOpen":"discovery-suggestions-module__isOpen--g2sKA"};